module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bmSq1x/tc-custom/9781426890208.jpg?1743947449947",
      "alt": "This image is the cover for the book Love & Scandal"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Love & Scandal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Nothing sells like love & scandal...")]), _c('br'), _c('br'), _vm._v("Collette Jardiniere writes of passion and seduction but has experienced neither. Her pseudonymous novel, "), _c('i', [_vm._v("The Last Days of a Rake,")]), _vm._v(" has shocked Victorian society "), _c('i', [_vm._v("and")]), _vm._v(" become a runaway bestseller. Infamous roué Charles Jameson is \"revealed\" as the author, and Collette is outraged when the cad does little to curtail the gossip."), _c('br'), _c('br'), _vm._v("Intrigued by the book the tabloids claim is his thinly veiled autobiography, Jameson tries to find the "), _c('i', [_vm._v("real")]), _vm._v(" author. Returning to London after an unsuccessful hunt, he is pleasantly distracted by a plain country miss reading the wicked book."), _c('br'), _c('br'), _vm._v("Collette is dismayed when she learns the identity of the devastatingly handsome man who kissed her senseless. And Jameson cannot believe that "), _c('i', [_vm._v("she")]), _vm._v(" wrote "), _c('i', [_vm._v("The Last Days of a Rake.")]), _vm._v(" As Collette tries to convince him of the truth, their mutual attraction reaches a fever pitch, and soon they find themselves in a real-life scandal!"), _c('br'), _c('br'), _vm._v("93,000 words\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Donna Lea Simpson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Carina Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0